module.exports = __webpack_public_path__ + "static/media/shaff1109.536c7c64.jpg";